export default __webpack_public_path__ + "static/media/discipline-law.ebc442ce.svg";